import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.scorecard`,
    defaultMessage: 'Scorecard',
  },
  description: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.description`,
    defaultMessage: 'Attach a scorecard to evaluate the applicant.',
  },
  addScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.addScorecard`,
    defaultMessage: 'Add Scorecard',
  },
  removeScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.removeScorecard`,
    defaultMessage: 'Remove scorecard',
  },
  removeScorecardConfirmation: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.removeScorecardConfirmation`,
    defaultMessage:
      'Are you sure you want to remove "{name}" from this stage? Evaluators will no longer be asked to score applicants here.',
  },
  unavailableScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.unavailableScorecard`,
    defaultMessage: 'Unavailable scorecard',
  },
  requireScoreCards: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.requireScoreCards`,
    defaultMessage: 'Require scorecard before advancing or rejecting',
  },
  requireScoreCardsDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.requireScoreCardsDescription`,
    defaultMessage:
      'Enforcement is not enabled yet. This setting is saved for a later release.',
  },
  requiredSubmissions: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.requiredSubmissions`,
    defaultMessage: 'Required submissions',
  },
  allAssignedEvaluators: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.allAssignedEvaluators`,
    defaultMessage: 'All assigned evaluators',
  },
  atLeastOneSubmission: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.atLeastOneSubmission`,
    defaultMessage: 'At least one submission',
  },
  atLeastASpecificNumber: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.atLeastASpecificNumber`,
    defaultMessage: 'At least a specific number',
  },
  requiredSubmissionsCountError: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.requiredSubmissionsCountError`,
    defaultMessage: 'Must be greater than 0',
  },
});
